import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { FindInformationMegaMenuComponent } from '@app/components/find-information/find-information-mega-menu/find-information-mega-menu.component';
import { WidgetPlaceholderModule } from '@app/components/widget-placeholder/widget-placeholder.component';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'cafcass-custom-find-information-mega-menu',
  templateUrl: './custom-find-information-mega-menu.component.html',
  styleUrls: ['./custom-find-information-mega-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomFindInformationMegaMenuComponent extends FindInformationMegaMenuComponent {

}
@NgModule({
  declarations: [CustomFindInformationMegaMenuComponent],
  exports: [
    CustomFindInformationMegaMenuComponent
  ],
  imports: [
    CommonModule,
    WidgetPlaceholderModule,
    LinkModule,
  ]
})
export class CustomFindInformationMegaMenuModule { }
